/**
 * Shapeway's Center Content layout for noty.
 */

module.exports = function($) {

  $.noty.layouts.swCenterContent = {
    name: 'swCenterContent',
    options: {
    },
    container: {
      object: '<ul id="noty_swCenterContent_layout_container" />',
      selector: 'ul#noty_swCenterContent_layout_container',
      style: function () {}
    },
    parent: {
      object: '<li />',
      selector: 'li',
      css: {}
    },
    css: {
      display: 'none'
    },
    animation: {
      open: 'animated fadeIn', // Animate.css class names
      close: 'animated fadeOut' // Animate.css class names
    }
  };

};
